'use client';

import { StatsTeamHeader } from '@/components/atoms';
import { StatsTableRow } from '@/components/molecules';
import { Division, DivisionAnalyticsDto } from '@/infrastructure/network/dto/PlayerStatsDto';

export const GameStatsTable = ({ divisions }: DivisionAnalyticsDto) => {
	const headerCellStyle = 'px-3 py-3 sm:px-6 font-medium text-gray-600 text-start';

	return (
		<div className="flex flex-col gap-4">
			{divisions?.length > 0 && <h2 className="text-2xl font-semibold leading-8 text-darkorange-400">Stats</h2>}

			{divisions?.map((item: Division) => {
				return (
					<div key={item.divisonUuid} className="flex h-auto max-w-[730px] flex-col gap-5 rounded-lg bg-white shadow-md">
						<StatsTeamHeader
							divisionSkillFrom={item.divisionSkillFrom}
							divisionSkillTo={item.divisionSkillTo}
							divisionAgeFrom={item.divisionAgeFrom}
							divisionAgeTo={item.divisionAgeTo}
							team={item.teamName}
							teamCaptain={item.captainFullName}
						/>

						<table className="w-full table-auto">
							<thead>
								<tr className="h-11 items-start text-wrap bg-darkorange-100 text-xs font-light leading-[18px] text-gray-600">
									<th className={`${headerCellStyle}`}>Wins</th>
									<th className={`${headerCellStyle}`}>Losses</th>
									<th className={`${headerCellStyle}`}>Points earned</th>
									<th className={`${headerCellStyle}`}>Points against</th>
									<th className={`${headerCellStyle}`}>Point differential %</th>
								</tr>
							</thead>
							<tbody>
								<StatsTableRow playerStats={item.winLossDivisionAnalytics} />
							</tbody>
						</table>
					</div>
				);
			})}
		</div>
	);
};
